module.exports = __webpack_public_path__ + "static/media/content-creator-icon.9049d8b4.svg";